// extracted by mini-css-extract-plugin
export default {"root":"reZQ2Ssrk5","divider":"hxTfQDnV2T"};